// extracted by mini-css-extract-plugin
export var form = "form-module--form--3aIpi";
export var nullValue = "form-module--nullValue--2cWft";
export var error = "form-module--error--3mwPw";
export var errorMessage = "form-module--errorMessage--IcG-o";
export var consentStatement = "form-module--consentStatement--uu1ZT";
export var radio = "form-module--radio--2o-Ud";
export var consentArea = "form-module--consentArea--nEr8h";
export var textArea = "form-module--textArea--1kvU3";
export var selectLabel = "form-module--selectLabel--1Hlis";
export var selectLabelIpo = "form-module--selectLabelIpo--1gJOp";
export var buttonArea = "form-module--buttonArea--3OMfm";
export var formIpo = "form-module--formIpo--5JbK_";
export var confirmIpo = "form-module--confirmIpo--2y5g9";